/**
 * 学习乐园 · 连连看题材包：货币配国家（lianliankan/pack-huobi.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：货币连国家或地区（「日元」连「日本」）。收的是新闻和
 * 旅行里最常出现的二十六种：亚洲（人民币、日元、韩元、卢比、泰铢、
 * 新加坡元、林吉特、印尼盾、里拉、越南盾、菲律宾比索、沙特里亚尔）、
 * 欧美与大洋洲非洲（美元、欧元、英镑、加元、澳元、新西兰元、瑞士法郎、
 * 卢布、瑞典克朗、挪威克朗、丹麦克朗、雷亚尔、兰特、埃及镑、墨西哥比索）。
 * note 给货币符号或一个识别点——配对的同时把「哪种钱长什么样」带上。
 * 欧元的搭档写「欧元区」：它是欧盟多国共用的货币，不属单一国家，如实表述。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.huobi = {
    id: 'huobi',
    name: '货币配国家',
    hint: '哪个国家用哪种钱',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '人民币', r: '中国', note: '符号 ¥，单位是元' },
      { l: '美元', r: '美国', note: '符号 $，全球储备货币' },
      { l: '欧元', r: '欧元区', note: '符号 €，欧盟多国共用' },
      { l: '日元', r: '日本', note: '纸币上印着福泽谕吉' },
      { l: '韩元', r: '韩国', note: '符号 ₩' },
      { l: '英镑', r: '英国', note: '符号 £，最古老的币种之一' },
      { l: '卢布', r: '俄罗斯', note: '符号 ₽' },
      { l: '卢比', r: '印度', note: '符号 ₹' },
      { l: '泰铢', r: '泰国', note: '符号 ฿' },
      { l: '新加坡元', r: '新加坡', note: '符号 S$，跟美元区分' },
      { l: '加元', r: '加拿大', note: '符号 C$，纸币上有潜鸟' },
      { l: '澳元', r: '澳大利亚', note: '符号 A$，塑料钞票首创' },
      { l: '瑞士法郎', r: '瑞士', note: '钟表王国的硬通货' },
      { l: '林吉特', r: '马来西亚', note: '符号 RM' },
      { l: '印尼盾', r: '印度尼西亚', note: '万岛之国的货币' },
      { l: '里拉', r: '土耳其', note: '横跨欧亚的货币' },
      { l: '雷亚尔', r: '巴西', note: '南美最大经济体的货币' },
      { l: '兰特', r: '南非', note: '好望角所在国的货币' },
      { l: '越南盾', r: '越南', note: '纸币面额动辄几千' },
      { l: '菲律宾比索', r: '菲律宾', note: '符号 ₱' },
      { l: '新西兰元', r: '新西兰', note: '符号 NZ$，硬币上有奇异鸟' },
      { l: '挪威克朗', r: '挪威', note: '峡湾之国的货币' },
      { l: '丹麦克朗', r: '丹麦', note: '安徒生故乡的货币' },
      { l: '沙特里亚尔', r: '沙特阿拉伯', note: '石油王国的货币' },
      { l: '埃及镑', r: '埃及', note: '金字塔之国的货币' },
      { l: '墨西哥比索', r: '墨西哥', note: '美元符号 $ 的「祖先」' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
